import type { CSSProperties } from "react";
import type { LucideIcon } from "lucide-react";
import {
  BookOpen,
  Building2,
  Droplets,
  Factory,
  Handshake,
  Leaf,
  Recycle,
  Waves,
} from "lucide-react";

import styles from "./styles.module.css";

interface SdgBadgeProps {
  number: number;
  label: string;
}

/** UN SDG 官方色 + 对应语义图标 */
const SDG_META: Record<number, { color: string; Icon: LucideIcon }> = {
  4: { color: "#C5192D", Icon: BookOpen },
  6: { color: "#26BDE2", Icon: Droplets },
  9: { color: "#FD6925", Icon: Factory },
  11: { color: "#FD9D24", Icon: Building2 },
  12: { color: "#BF8B2E", Icon: Recycle },
  13: { color: "#3F7E44", Icon: Leaf },
  14: { color: "#0A97D9", Icon: Waves },
  17: { color: "#19486A", Icon: Handshake },
};

export function SdgBadge({ number, label }: SdgBadgeProps) {
  const meta = SDG_META[number];
  const Icon = meta?.Icon ?? Droplets;
  const color = meta?.color ?? "#0A97D9";

  return (
    <div className={styles.badge} data-reveal style={{ "--sdg-color": color } as CSSProperties}>
      <span className={styles.icon} aria-hidden="true">
        <Icon size={22} strokeWidth={2} />
      </span>
      <div className={styles.copy}>
        <span className={styles.number}>SDG {number}</span>
        <span className={styles.label}>{label}</span>
      </div>
    </div>
  );
}

export default SdgBadge;
